import React from "react";

const StatCard = ({ title, value, description, icon, color }) => {
  return (
    <div
      className={`relative bg-white dark:bg-gray-300 shadow-md rounded-lg p-6 flex flex-col items-center text-center space-y-2 border-l-8 ${color}`}
    >
      {/* Icône en haut */}
      <div className="text-4xl">{icon}</div>

      {/* Titre */}
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-800">
        {title}
      </h3>

      {/* Valeur en gras et bien visible */}
      <p className="text-4xl font-bold text-blue-600">{value}%</p>

      {/* Description optionnelle */}
      {description && (
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {description}
        </p>
      )}
    </div>
  );
};

export default StatCard;
